import { defineComponent as d, createBlock as o, openBlock as n, Transition as m, mergeProps as s, withCtx as r, withDirectives as f, createCommentVNode as a, KeepAlive as u, normalizeProps as k, renderSlot as t, vShow as v } from "vue";
import i from "./TransitionableSlot.vue2.js";
const A = /* @__PURE__ */ d({
  __name: "TransitionContent",
  props: {
    keepAlive: { type: Boolean },
    keepAliveProps: {},
    transitionProps: {},
    renderBody: { type: Boolean },
    condition: { type: Boolean }
  },
  emits: ["leave"],
  setup(y) {
    return (e, l) => (n(), o(m, s(e.transitionProps, {
      onLeave: l[0] || (l[0] = (p) => e.$emit("leave", p))
    }), {
      default: r(() => [
        e.keepAlive ? (n(), o(u, k(s({ key: 0 }, e.keepAliveProps)), [
          e.condition ? (n(), o(i, { key: 0 }, {
            default: r(() => [
              t(e.$slots, "default")
            ]),
            _: 3
          })) : a("", !0)
        ], 1040)) : e.condition && !e.renderBody ? (n(), o(i, { key: 1 }, {
          default: r(() => [
            t(e.$slots, "default")
          ]),
          _: 3
        })) : e.renderBody ? f((n(), o(i, { key: 2 }, {
          default: r(() => [
            t(e.$slots, "default")
          ]),
          _: 3
        }, 512)), [
          [v, e.condition]
        ]) : a("", !0)
      ]),
      _: 3
    }, 16));
  }
});
export {
  A as default
};
